import { Fragment } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../state/actions";
import LazyLoadImg from "../../shared/lazyLoadImg/LazyLoadImg";
import CustomButton from "../../shared/customButton/CustomButton";
import { BASENAME } from "../../../utils/basename";
import { URLASSOLUTO } from "../../../utils/urlassoluto";
import { BASESTORAGE } from "../../../utils/basestorage";

const PackageBoxItem = ({
  categoryId,
  immagine,
  titoloText = null,
  titoloCategoria = null,
  sottotitolo = null,
  colore,
  routeName = null,
  linkSeo = null,
  buttonText = null,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentLang = useSelector((state) => state.currentPage.currentLang);
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );

  const onPackageClick = (event) => {
    event.preventDefault();

    // mostro spinner
    dispatch(allActions.isFetchingAction.loadSpinner());

    dispatch(
      allActions.changePageActions.changePage(
        categoryId,
        routeName,
        linkSeo,
        history
      )
    );
  };

  const immagineElenco =
    immagine === null || immagine?.file_name === undefined ? (
      <LazyLoadImg
        imgName="placeholder_elenco_prodotto.jpg"
        imgPath="statiche"
        imgWidth="300"
        imgHeight="232"
        imgStyle="flex-start mb-3 w-full object-fit cursor-pointer"
        imgAlt={genericheTranslation[titoloText].itemName}
      />
    ) : (
      <LazyLoadImg
        imgName={`300x232-${immagine.file_name.replace(".jpg", ".webp")}`}
        imgPath={`${immagine.folder}/thumbs`}
        imgWidth="300"
        imgHeight="232"
        imgStyle="flex-start mb-3 w-full object-fit cursor-pointer"
        imgAlt={genericheTranslation[titoloText].itemName}
      />
    );

  const titoloCategoriaToShow = titoloCategoria ? titoloCategoria : "";

  const titoloFormatted = (
    <span
      className={`titolo leading-tight line-clamp-3 block text-${colore} mb-3`}
    >
      {genericheTranslation[titoloText].itemName} {titoloCategoriaToShow}
    </span>
  );

  const buttonTextToShow = buttonText
    ? genericheTranslation[buttonText].itemName
    : genericheTranslation.continua.itemName;
 
  return (
    <div className="col-span-60 sm:col-span-30 md:col-span-20 xl:col-span-15 mb-10 flex justify-center">
      <div className="productBoxItem productBoxItem-amber border-t border-gray-200 max-w-xs sm:max-w-none mx-8 sm:mx-4 md:mx-2 lg:mx-3 xl:mx-2 4xl:mx-4">
        <a
          href={URLASSOLUTO + linkSeo}
          onClick={onPackageClick}
          className="text-lg md:text-sm 3xl:text-base sm:h-20 block"
        >
          {titoloFormatted}
        </a>
        <a
          href={URLASSOLUTO + linkSeo}
          onClick={onPackageClick}
          className="block h-52 overflow-hidden mb-2"
        >
          {immagineElenco}
        </a>
        <span
          className="sottotitolo line-clamp-3 text-sm block sm:h-16"
          dangerouslySetInnerHTML={{
            __html: sottotitolo,
          }}
        />
        <CustomButton
          buttonId={categoryId}
          buttonLink={linkSeo}
          buttonRouteName={routeName}
          buttonName={buttonTextToShow}
          buttonStyle="dettagliButton text-sm pl-4 pr-16 py-2 3xl:py-3 mt-2"
        />
      </div>
    </div>
  );
};

export default PackageBoxItem;
